import { fieldsTimeOutValue } from "components/Field/index";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { uniqueId } from "utils";

const DateField = ({
  date,
  setDate,
  dateError,
  setDateError,
  validator,
  labelText,
}) => {
  const id = uniqueId();

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (validator) {
        validator(date, setDateError);
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [date]);

  return (
    <label htmlFor={`${id}_form_field-date`} className="form__field__date">
      <span>
        <b>{labelText || "Date"}</b>
      </span>
      <DatePicker
        className={dateError && "input__error"}
        id={`${id}_form_field-date`}
        selected={date}
        onChange={(d) => {
          setDate(d);
          if (initialLoad) {
            setInitialLoad(false);
          }
        }}
        dateFormat="dd/MMMM/yyyy"
        placeholderText="Day/Month/Year"
      />
      <span className={`input__error__message ${dateError && "show"}`}>
        {dateError}
      </span>
    </label>
  );
};

export default DateField;

DateField.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  setDate: PropTypes.func.isRequired,
  dateError: PropTypes.string.isRequired,
  setDateError: PropTypes.func,
  validator: PropTypes.func,
  labelText: PropTypes.string,
};
